import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Column } from '../../ng2-smart-table/lib/data-set/column';

@Component({
    selector: 'de-check-box-cell',
    templateUrl: './check-box-cell.component.html',
    styleUrls: ['./check-box-cell.component.scss'],
    standalone: false
})
export class CheckBoxCellComponent implements ViewCell, OnInit {
  value: any;
  rowData: any;
  settings: Column;

  constructor() { 
  }

  ngOnInit(): void {
  }

}
